
import {useUnteraufgabenHandling} from "../../hooks/unteraufgaben/useUnteraufgabenHandling";
import {ANTWORTTYPEN} from "../../models/Antworttypen";
import {capitalize, MenuItem} from "@mui/material";
import {Select} from "formik-mui";
import {FastField} from "formik";

interface AntworttypSelectProps {
    id: string;
    key?: string;
    name: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
}

export default function AntworttypSelect({id, key, name, label, required, disabled}: AntworttypSelectProps) {
    const {translation} = useUnteraufgabenHandling();

    return (
        <FastField id={id}
                   key={key}
                   name={name}
                   label={label}
                   component={Select}F
                   required={required}
                   disabled={disabled}
        >
            {ANTWORTTYPEN.map((typ) => (
                <MenuItem id={typ}
                          key={typ}
                          value={typ}
                >
                    {capitalize(translation(`answer-type-${typ.toLowerCase()}`))}
                </MenuItem>
            ))}
        </FastField>
    )
}